import { baseMakeRequest, makeRequest, networkGlobals } from "./networkUtils";

/** credentionals for auth */
export const authDO = async (email, password, host) => {
  return makeRequest("auth/", { method: "POST", body: { email: email.toLowerCase(), password, host}, withoutError:true ,withCredentials: true});
};

export const checkAuthDO = async () => {
  return makeRequest("auth/checkAuth", { method: "GET" });
};

let refreshPromise: Promise<void> | null = null;


export const refreshAuthDO = async () => {
  const token = localStorage.getItem("BOToken") || "";
  if (isTokenExpired(token)) {
    // Try to refresh
    try {
    if (!refreshPromise) {  
      refreshPromise = baseMakeRequest("auth/refresh", { method: "POST", withCredentials: true,auth: false, withoutError: true });
    }
    const res: any = await refreshPromise;
    refreshPromise = null;
    if (res && res.token) {
      localStorage.setItem("BOToken", res.token);
    } else {
        throw new Error("Session expired");
      }
    } catch (error) {
      localStorage.removeItem("BOToken");
      console.error("Failed to refresh auth:", error);
      window.location.href = "#/sign-in";
      throw new Error("Session expired");
    }
  }
}


// Helper to decode JWT and check expiration
function isTokenExpired(token: string): boolean {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    // exp is in seconds, Date.now() is ms
    return (payload.exp * 1000) < (Date.now() + 5000); // consider expired if less than 5s left
  } catch (e) {
    return true;
  }
}